import { Svg } from "../svg";
import { IconType } from "../../models";

export const IconTelegram: IconType = ({ className = "" }) => (
  <Svg className={className} viewBox="0 0 31 31">
    <path
      d="M7.16233 15.828C8.69709 14.9014 10.4095 14.1265 12.0098 13.3484C14.7634 12.0734 17.5271 10.8224 20.32 9.65612C20.8631 9.458 21.8387 9.26308 21.9348 10.1466C21.8824 11.3976 21.6669 12.6406 21.5184 13.8836C21.1427 16.6173 20.7087 19.3414 20.2865 22.0654C20.1409 22.9729 19.1041 23.4427 18.4415 22.8627C16.8485 21.682 15.2424 20.5125 13.6698 19.3046C13.1543 18.7294 13.6319 17.905 14.0921 17.4944C15.4041 16.0757 16.7961 14.8694 18.0397 13.3772C18.3746 12.4888 17.3844 13.2366 17.0568 13.4666C15.2599 14.8247 13.5082 16.2658 11.6137 17.4609C10.6469 18.0456 9.51835 17.5456 8.55148 17.2196C7.68508 16.825 6.41388 16.4288 7.16087 15.828H7.16233Z"
      fill="#F8F7F6"
    />
    <circle
      cx="15.8357"
      cy="15.1152"
      r="14.25"
      stroke="#F8F7F6"
      stroke-width="1.5"
    />
  </Svg>
);
